import { useContext, useEffect, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import { goToBackPageTransformer } from "../../utils";
import ButtonBack from "../../UI/ButtonBack/ButtonBack";


const ReportMasRegionPharmacyPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getCategoriesForMasRegionPharmacyReport } = useContext(AdminContext);
  const [categories, setCategories] = useState(null);
  const goBack = () => {
    // console.log(window.history);
    // console.log(location.pathname)
    if (window.history.length > 3) {
      navigate(-1); // Переход на предыдущую страницу в истории
    } else {
      // console.log(location)
      navigate(goToBackPageTransformer(1, location.pathname)) 
    }
  };


  useEffect(() => {
    document.title = 'Масы + Регионы + Аптеки'
    getCategoriesForMasRegionPharmacyReport().then((res) => {
      setCategories(res.data);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="container">
     
      <ButtonBack shortBtn={true}/>

      {!categories ? (
        <div style={{marginTop: 50, position: 'relative'}}>
          <CoveredBackground>
            <Loader/>
          </CoveredBackground>


        </div>
      ) : categories.length ? (
        <div className="admin__all__results">
          <div className="admin__all__results__items">
            {
              categories.map((category, id) =>(
                <Link
                to={"/admin/reports/mas-region-pharmacy/"+category.id}
                className="admin__all__results__item"
                key={id}
              >
                {category.category}
              </Link>
              ))
            }
           
          </div>
        </div>
      ) : (
        <p
          style={{
            textAlign: "center",
            color: "crimson",
            fontSize: 30,
            marginTop: 60,
          }}
        >
          error
        </p>
      )}
    </div>
  );
};

export default ReportMasRegionPharmacyPage;
